import IssueManagement from './IssueManagement'

export default IssueManagement
